export const analyticsEvents = {
	statAdded: "stat_added",
	statDeleted: "stat_deleted",
	statFlagged: "stat_flagged",
	chartEdited: "chart_edited",
	chartCreated: "chart_created",
	chartPopulated: "chart_populated",
};
